export default __webpack_public_path__ + "static/joko-app-screenshot-home-2-fr@2x-45d9ce8b3b5214bc7f752f8ad8761ee5.png";